export default {
    methods: {
        setValidationErrors(actions, errors, root = '') {
            for (const [key, value] of Object.entries(errors)) {
                if(Array.isArray(value) && value.length) {
                    if(typeof value[0] === 'string') {
                        actions.setFieldError(root + key, value[0])
                    } else {
                        value.forEach((item, index) => {
                            this.setValidationErrors(actions, item, root + key + '[' + index + '].')
                        })
                    }
                } else {
                    this.setValidationErrors(actions, value, root + key + '.')
                }
            }
            this.focusErrorField(actions, errors)
        },
        focusErrorField(actions, errors, root = '') {
            for (const [key, value] of Object.entries(errors)) {
                if(Array.isArray(value) && value.length) {
                    if(typeof value[0] === 'string') {
                        let el = document.getElementsByName(root + key)[0]
                        if(el) {
                            el.focus()
                            return
                        }
                    } else {
                        value.forEach((item, index) => {
                            this.focusErrorField(actions, item, root + key + '[' + index + '].')
                        })
                    }
                } else {
                    this.focusErrorField(actions, value, root + key + '.')
                }
            }
        }
    }
}